import { CLIENT_HOLDINGS_REPORT_PARAMETER_FORM, HOLDINGS_REPORT_PARAMETER_FORM, REPORT_IDS, REPORT_REGISTRY, } from './report-dashboard-registry.js';
import { CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_READ_OWN, PORTFOLIO_CUSTODY_EVIDENCE_LIST, } from '../operations/portfolio-custody.operations.js';
export const PORTFOLIO_CUSTODY_EVIDENCE_REPORT_ID = 'report.portfolio.custody-evidence';
export const CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_REPORT_ID = 'report.client.custody-evidence';
export const PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM_ID = 'form.reports.portfolioCustodyEvidenceParameters';
export const CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM_ID = 'form.reports.clientPortfolioCustodyEvidenceParameters';
function custodyForm(options) {
    const fields = options.base.fields.filter((field) => field.name !== 'asOfDate' &&
        (!options.removeClientSelector || field.name !== 'clientAccountId'));
    return Object.freeze({
        ...options.base,
        id: options.id,
        titleKey: 'reports.custodyParameters.title',
        descriptionKey: 'reports.custodyParameters.description',
        operationId: options.operationId,
        accessibilityLabelKey: 'a11y.form.reports.portfolioCustodyEvidence',
        fields,
        sections: [
            {
                id: `form.reports.${options.prefix}.section.parameters`,
                titleKey: 'reports.runForm.parametersSection',
                fields: fields.map((field) => field.id),
                layout: { columns: 2, gap: 16 },
            },
        ],
        actions: options.base.actions.map((action) => ({
            ...action,
            operationId: options.operationId,
            telemetryId: `${String(action.telemetryId)}.${options.prefix}`,
        })),
        submission: {
            ...options.base.submission,
            includeFields: fields.map((field) => field.id),
        },
    });
}
export const PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM = custodyForm({
    base: HOLDINGS_REPORT_PARAMETER_FORM,
    id: PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM_ID,
    operationId: PORTFOLIO_CUSTODY_EVIDENCE_LIST,
    prefix: 'portfolioCustodyEvidence',
});
export const CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM = custodyForm({
    base: CLIENT_HOLDINGS_REPORT_PARAMETER_FORM,
    id: CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM_ID,
    operationId: CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_READ_OWN,
    prefix: 'clientPortfolioCustodyEvidence',
    removeClientSelector: true,
});
function column(field, labelKey, fieldType = 'text') {
    return {
        id: `column.report.portfolioCustody.${field}`,
        schemaVersion: 1,
        module: 'REPORTING',
        feature: 'reports.view',
        privacyClassification: 'FINANCIAL',
        telemetryId: `experience.column.report.portfolioCustody.${field}`,
        accessibilityLabelKey: labelKey,
        availability: 'AVAILABLE',
        owner: 'portfolio-custody-evidence',
        labelKey: labelKey,
        field,
        fieldType,
        defaultVisible: true,
        hideable: true,
        sortable: false,
        filterable: false,
        searchable: false,
        groupable: false,
        resizable: true,
        reorderable: true,
        pinnable: false,
        minWidth: 90,
        defaultWidth: field.includes('Reference') ? 190 : 145,
        nullDisplayBehavior: 'dash',
    };
}
export const PORTFOLIO_CUSTODY_EVIDENCE_COLUMNS = Object.freeze([
    column('portfolioReference', 'reports.custodyColumns.portfolio'),
    column('identifierType', 'reports.custodyColumns.identifierType'),
    column('participantIdentifier', 'reports.custodyColumns.participantIdentifier'),
    column('primaryIdentifierMasked', 'reports.custodyColumns.primaryIdentifier'),
    column('ownerType', 'reports.custodyColumns.ownerType'),
    column('positionCount', 'reports.custodyColumns.positionCount', 'number'),
    column('instrumentCount', 'reports.custodyColumns.instrumentCount', 'number'),
    column('identityComplete', 'reports.custodyColumns.identityComplete', 'boolean'),
    column('externalStatementAvailable', 'reports.custodyColumns.externalStatementAvailable', 'boolean'),
    column('externalStatementVerified', 'reports.custodyColumns.externalStatementVerified', 'boolean'),
    column('balanceReconciliationState', 'reports.custodyColumns.reconciliationState', 'status'),
    column('evidenceAsOf', 'reports.custodyColumns.evidenceAsOf', 'datetime'),
]);
function custodyReport(options) {
    const base = REPORT_REGISTRY[options.baseReportId];
    return Object.freeze({
        ...base,
        id: options.id,
        reportType: options.reportType,
        titleKey: options.titleKey,
        descriptionKey: options.descriptionKey,
        category: 'HOLDINGS',
        scope: options.scope,
        operationId: options.operationId,
        telemetryId: `experience.report.${options.suffix}`,
        accessibilityLabelKey: options.titleKey,
        dataSourceId: 'query.reports.portfolioCustodyEvidence',
        parameterFormId: options.form.id,
        runFormId: options.form.id,
        columns: [...PORTFOLIO_CUSTODY_EVIDENCE_COLUMNS],
        allowedFormats: ['json'],
        formats: ['json'],
        generatorId: `live.generator.${options.suffix}`,
        executionMode: 'LIVE_QUERY',
        operationBindings: {
            listOperationId: options.operationId,
            runOperationId: options.operationId,
        },
        lineage: {
            sourceSystem: 'portfolio-custody-evidence',
            sourceEntities: [
                'PortfolioAccount',
                'PortfolioHolding',
                'ClientAccountDocument',
                'CustodyPositionObservation',
            ],
            calculationVersion: 'portfolio-custody-evidence-v1',
        },
        implemented: true,
        auditPolicy: 'ALWAYS',
    });
}
export const PORTFOLIO_CUSTODY_EVIDENCE_REPORT = custodyReport({
    baseReportId: REPORT_IDS.PORTFOLIO_HOLDINGS,
    id: PORTFOLIO_CUSTODY_EVIDENCE_REPORT_ID,
    reportType: 'PORTFOLIO_CUSTODY_EVIDENCE',
    operationId: PORTFOLIO_CUSTODY_EVIDENCE_LIST,
    form: PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM,
    scope: 'BRANCH',
    titleKey: 'reports.types.portfolioCustodyEvidence',
    descriptionKey: 'reports.descriptions.portfolioCustodyEvidence',
    suffix: 'portfolioCustodyEvidence',
});
export const CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_REPORT = custodyReport({
    baseReportId: REPORT_IDS.CLIENT_HOLDINGS,
    id: CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_REPORT_ID,
    reportType: 'CLIENT_PORTFOLIO_CUSTODY_EVIDENCE',
    operationId: CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_READ_OWN,
    form: CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM,
    scope: 'CLIENT',
    titleKey: 'reports.types.clientPortfolioCustodyEvidence',
    descriptionKey: 'reports.descriptions.clientPortfolioCustodyEvidence',
    suffix: 'clientPortfolioCustodyEvidence',
});
export const PORTFOLIO_CUSTODY_EVIDENCE_REPORT_REGISTRY = Object.freeze({
    [PORTFOLIO_CUSTODY_EVIDENCE_REPORT_ID]: PORTFOLIO_CUSTODY_EVIDENCE_REPORT,
    [CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_REPORT_ID]: CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_REPORT,
});
export const PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORMS = Object.freeze({
    [PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM.id]: PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM,
    [CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM.id]: CLIENT_PORTFOLIO_CUSTODY_EVIDENCE_REPORT_FORM,
});
